/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-30 11:44:59
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-06-30 13:06:30
 * @FilePath: /zeelool-nextjs/src/app/payment/components/AnniversaryGift/index.tsx
 * @Description: 周年礼物组件
 */
import { useStore } from '@/providers/app-store-provider';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { getGiftStatusText } from '@/utils/shipping';
import Image from '@/components/Image';
import styles from './styles.module.css';

interface AnniversaryGiftProps {
  giftStatus: number;
  giftActivityImage: string;
}

export default function AnniversaryGift({ giftStatus, giftActivityImage }: AnniversaryGiftProps) {
  const currency = useStore((state) => state.currency);

  return (
    <div className="bg-white rounded-[5px] w-full py-[12px] px-[1.5625vw] mb-[12px]">
      <div className={`${styles.anniversaryGift} ${giftStatus === 4 ? styles.disabled : ''}`}>
        <div className={styles.leftBox}>
          <Image src={giftActivityImage} className={styles.giftImg} alt="" width={72} height={72} />
          <div className={styles.priceBox}>
            <span className="notranslate">{formatPriceNumberWithSymbol('0.00', currency)}</span>
            <span>X {giftStatus === 3 ? 1 : 0}</span>
          </div>
        </div>
        <div className={styles.rightBox}>{getGiftStatusText(giftStatus)}</div>
      </div>
    </div>
  );
}
